export type SettingtRiceLevelRang = {
  min: number;
  max: number;
  description?: {
    value?: number;
    image?: {
      normal?: string;
      highlight?: string;
      color?: string;
    };
  }[];
  convert?: {
    toValue: (value: number) => number;
    toLevel: (value: number) => number;
  };
};

export type RiceOfSetting = TypeRiceSettingValues;

type ISettingRiceLevel = {
  [x in RiceOfSetting]: SettingtRiceLevelRang;
};

export const SETTING_RICE_LEVEL: ISettingRiceLevel = {
  undermilled: {
    min: 1,
    max: 4,
    description: [
      {
        value: 1,
        image: {
          normal: "/image/UnderMill/JPG/UMlv1_1.jpg",
          highlight: "/image/UnderMill/JPG/UMlv1_2.jpg",
        },
      },
      {
        value: 2,
        image: {
          normal: "/image/UnderMill/JPG/UMlv2_1.jpg",
          highlight: "/image/UnderMill/JPG/UMlv2_2.jpg",
        },
      },
      {
        value: 3,
        image: {
          normal: "/image/UnderMill/JPG/UMlv3_1.jpg",
          highlight: "/image/UnderMill/JPG/UMlv3_2.jpg",
        },
      },
      {
        value: 4,
        image: {
          normal: "/image/UnderMill/JPG/UMlv4_1.jpg",
          highlight: "/image/UnderMill/JPG/UMlv4_2.jpg",
        },
      },
    ],
  },
  chalky: {
    min: 1,
    max: 4,
    description: [
      {
        value: 1,
        image: {
          normal: "/image/Chalky/JPG/lv1_1.jpg",
          highlight: "/image/Chalky/JPG/lv1_2.jpg",
        },
      },
      {
        value: 2,
        image: {
          normal: "/image/Chalky/JPG/lv2_1.jpg",
          highlight: "/image/Chalky/JPG/lv2_2.jpg",
        },
      },
      {
        value: 3,
        image: {
          normal: "/image/Chalky/JPG/lv3_1.jpg",
          highlight: "/image/Chalky/JPG/lv3_2.jpg",
        },
      },
      {
        value: 4,
        image: {
          normal: "/image/Chalky/JPG/lv4_1.jpg",
          highlight: "/image/Chalky/JPG/lv4_2.jpg",
        },
      },
    ],
  },
  damage: {
    min: 1,
    max: 4,
    description: [
      {
        value: 1,
        image: {
          normal: "/image/Damaged/JPG/DMlv1_1.jpg",
          highlight: "/image/Damaged/JPG/DMlv1_2.jpg",
        },
      },
      {
        value: 2,
        image: {
          normal: "/image/Damaged/JPG/DMlv2_1.jpg",
          highlight: "/image/Damaged/JPG/DMlv2_2.jpg",
        },
      },
      {
        value: 3,
        image: {
          normal: "/image/Damaged/JPG/DMlv3_1.jpg",
          highlight: "/image/Damaged/JPG/DMlv3_2.jpg",
        },
      },
      {
        value: 4,
        image: {
          normal: "/image/Damaged/JPG/DMlv4_1.jpg",
          highlight: "/image/Damaged/JPG/DMlv4_2.jpg",
        },
      },
    ],
  },
  head: {
    min: 1,
    max: 4,
    description: [
      {
        value: 1,
        image: {
          normal: "/image/Head/H01.png",
        },
      },
      {
        value: 2,
        image: {
          normal: "/image/Head/H02.png",
        },
      },
      {
        value: 3,
        image: {
          normal: "/image/Head/H03.png",
        },
      },
      {
        value: 4,
        image: {
          normal: "/image/Head/H04.png",
        },
      },
    ],
    convert: {
      toLevel: (value) => +(value + 6).toFixed(0),
      toValue: (value) => +(value - 6).toFixed(0),
    },
  },
  yellow: {
    min: 1,
    max: 10,
    description: [
      {
        value: 1,
        image: {
          normal: "/image/Yellow/Y01.png",
          color: "#F4F1F2",
        },
      },
      {
        value: 2,
        image: {
          normal: "/image/Yellow/Y02.png",
          color: "#E2DEDB",
        },
      },
      {
        value: 3,
        image: {
          normal: "/image/Yellow/Y03.png",
          color: "#E0D7D1",
        },
      },
      {
        value: 4,
        image: {
          normal: "/image/Yellow/Y04.png",
          color: "#E5D9CB",
        },
      },
      {
        value: 5,
        image: {
          normal: "/image/Yellow/Y05.png",
          color: "#DCD1C3",
        },
      },
      {
        value: 6,
        image: {
          normal: "/image/Yellow/Y06.png",
          color: "#D9C1AA",
        },
      },
      {
        value: 7,
        image: {
          normal: "/image/Yellow/Y07.png",
          color: "#D9C199",
        },
      },
      {
        value: 8,
        image: {
          normal: "/image/Yellow/Y08.png",
          color: "#D8BD95",
        },
      },
      {
        value: 9,
        image: {
          normal: "/image/Yellow/Y09.png",
          color: "#C7A984",
        },
      },
      {
        value: 10,
        image: {
          normal: "/image/Yellow/Y10.png",

          color: "#CD9E79",
        },
      },
    ],
  },
};

export const selectDescriptionBylevel = (level: number, type: RiceOfSetting) => {
  const description = SETTING_RICE_LEVEL[type].description;
  if (!description) {
    return null;
  }
  return description.find((item) => item.value === level);
};

export const DEFAULT_LEVEL = {
  undermilled: 1,
  chalky: 2,
  damage: 1,
  yellow: 4,
  head: 7,
  isAutoYellow: false,
};

export const TYPE_RICE_SETTING = {
  UNDERMILLED: "undermilled",
  CHALKY: "chalky",
  DAMAGE: "damage",
  YELLOW: "yellow",
  HEAD: "head",
} as const;
export type TypeRiceSettingKeys = keyof typeof TYPE_RICE_SETTING;
export type TypeRiceSettingValues = typeof TYPE_RICE_SETTING[TypeRiceSettingKeys];
